import { render, staticRenderFns } from "./BrandEditPopup.vue?vue&type=template&id=40990029&scoped=true&"
import script from "./BrandEditPopup.vue?vue&type=script&lang=ts&"
export * from "./BrandEditPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BrandEditPopup.vue?vue&type=style&index=0&id=40990029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40990029",
  null
  
)

export default component.exports